<div [ngClass]="menuClass" cdkMenu>
  @for (item of menu; track item.routerLinkUrl) { @if (!item.children ||
  item.children.length === 0) {
  <button
    class="menu-item"
    cdkMenuItem
    [routerLink]="item.routerLinkUrl"
    routerLinkActive="menu-active"
    *ngxPermissionsOnly="item.permissionsOnly ?? []"
  >
    <mat-icon class="d-flex me-1" [svgIcon]="item.svgIcon"></mat-icon>
    <span>{{ item.title }}</span>
  </button>

  } @else {

  <button
    class="menu-item"
    cdkMenuItem
    (click)="item.isOpen = !item.isOpen"
    *ngxPermissionsOnly="item.permissionsOnly ?? []"
    [routerLink]="item.routerLinkUrl"
    routerLinkActive="nested-menu-active"
  >
    <mat-icon class="d-flex me-1" [svgIcon]="item.svgIcon"></mat-icon>
    <span>{{ item.title }}</span>
    <mat-icon
      class="d-flex ms-1"
      [svgIcon]="item.isOpen ? 'chevron-down' : 'chevron-right'"
    ></mat-icon>
  </button>
  @if (item.isOpen && item.children) {

  <ui-menu [menu]="item.children" menuClass="children-menu"></ui-menu>

  } } }
</div>
